<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>海外事务管理</el-breadcrumb-item>
      <el-breadcrumb-item>海外联系我们管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="姓名" prop="fullName">
              <el-input
                v-model="queryForm.fullName"
                placeholder="请输入姓名"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="queryForm.email"
                placeholder="请输入邮箱"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="国家" prop="country">
              <el-input
                v-model="queryForm.country"
                placeholder="请输入国家"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属机构" prop="institution">
              <el-input
                v-model="queryForm.institution"
                placeholder="请输入所属机构"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="处理状态" prop="status">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.status"
                clearable
              >
                <el-option label="待处理" :value="0"></el-option>
                <el-option label="已处理" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="getDataList('search')"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button
            type="primary"
            plain
            style="width: 100%"
            @click="reset"
            >重置</el-button
          >
        </el-col>
        <!-- <el-col :span="2">
          <el-button
            type="success"
            style="width: 100%"
            @click="handleAdd"
            >新增</el-button
          >
        </el-col> -->
      </el-row>
    </el-card>
    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">联系我们列表</span>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="姓名" prop="fullName"></el-table-column>
        <el-table-column label="邮箱" prop="email"></el-table-column>
        <el-table-column label="国家" prop="country"></el-table-column>
        <el-table-column label="所属机构" prop="institution"></el-table-column>
        <el-table-column label="备注" prop="note">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.note || '-'"
              placement="top"
            >
              <span class="text-ellipsis">{{ scope.row.note || '-' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="处理状态" prop="status" width="100px">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="warning" size="mini">待处理</el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="success" size="mini">已处理</el-tag>
            <el-tag v-else type="info" size="mini">-</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220px" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button
              type="text"
              size="small"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            > -->
            <el-button
              type="text"
              size="small"
              @click="handleUpdateStatus(scope.row)"
              >修改状态</el-button
            >
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="editDialogVisible"
      width="50%"
      @close="editDialogClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editFormRef"
        :rules="editRules"
        style="width: 100%"
      >
        <el-form-item label="姓名" prop="fullName">
          <el-input
            v-model="editForm.fullName"
            placeholder="请输入姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="editForm.email"
            placeholder="请输入邮箱"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="国家" prop="country">
          <el-input
            v-model="editForm.country"
            placeholder="请输入国家"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="所属机构" prop="institution">
          <el-input
            v-model="editForm.institution"
            placeholder="请输入所属机构"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input
            type="textarea"
            v-model="editForm.note"
            placeholder="请输入备注"
            :rows="4"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="处理状态" prop="status">
          <el-select
            v-model="editForm.status"
            placeholder="请选择处理状态"
            style="width: 100%"
          >
            <el-option label="待处理" :value="0"></el-option>
            <el-option label="已处理" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改状态对话框 -->
    <el-dialog
      title="修改处理状态"
      :visible.sync="statusDialogVisible"
      width="30%"
      @close="statusDialogClose"
    >
      <el-form
        :model="statusForm"
        label-width="100px"
        ref="statusFormRef"
        :rules="statusRules"
      >
        <el-form-item label="处理状态" prop="status">
          <el-select
            v-model="statusForm.status"
            placeholder="请选择处理状态"
            style="width: 100%"
          >
            <el-option label="待处理" :value="0"></el-option>
            <el-option label="已处理" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statusDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdateStatus">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getOverseasContactUsPage, addOverseasContactUs, updateOverseasContactUs, deleteOverseasContactUs, updateOverseasContactUsStatus } from '@/http/api'
export default {
  data () {
    return {
      queryForm: {
        fullName: '',
        email: '',
        country: '',
        institution: '',
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      dataList: [],
      total: 0,
      editDialogVisible: false, // 新增/编辑对话框显示状态
      statusDialogVisible: false, // 修改状态对话框显示状态
      dialogTitle: '新增',
      editForm: {
        id: null,
        fullName: '',
        email: '',
        country: '',
        institution: '',
        note: '',
        status: 0
      },
      editRules: {
        fullName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        country: [{ required: true, message: '请输入国家', trigger: 'blur' }],
        institution: [{ required: true, message: '请输入所属机构', trigger: 'blur' }],
        status: [{ required: true, message: '请选择处理状态', trigger: 'change' }]
      },
      statusForm: {
        id: null,
        status: null
      },
      statusRules: {
        status: [{ required: true, message: '请选择处理状态', trigger: 'change' }]
      }
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取列表信息
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      getOverseasContactUsPage(this.queryForm).then((res) => {
        console.log('getOverseasContactUsPage', res)
        this.dataList = res.data.list || []
        this.total = res.data.total || 0
      }).catch((err) => {
        console.log('err', err)
        this.$message.error('获取列表失败')
      })
    },
    // 重置搜索条件
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    // 新增
    handleAdd () {
      this.dialogTitle = '新增'
      this.editForm = {
        id: null,
        fullName: '',
        email: '',
        country: '',
        institution: '',
        note: '',
        status: 0
      }
      this.editDialogVisible = true
    },
    // 编辑
    handleEdit (row) {
      this.dialogTitle = '编辑'
      this.editForm = {
        id: row.id,
        fullName: row.fullName,
        email: row.email,
        country: row.country,
        institution: row.institution,
        note: row.note,
        status: row.status
      }
      this.editDialogVisible = true
    },
    // 提交新增/编辑
    submitEdit () {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return

        if (this.editForm.id) {
          // 编辑
          updateOverseasContactUs(this.editForm).then((res) => {
            console.log('updateOverseasContactUs', res)
            this.$message.success('编辑成功')
            this.editDialogVisible = false
            this.getDataList()
          }).catch((err) => {
            console.log('编辑失败', err)
            this.$message.error('编辑失败')
          })
        } else {
          // 新增
          addOverseasContactUs(this.editForm).then((res) => {
            console.log('addOverseasContactUs', res)
            this.$message.success('新增成功')
            this.editDialogVisible = false
            this.getDataList()
          }).catch((err) => {
            console.log('新增失败', err)
            this.$message.error('新增失败')
          })
        }
      })
    },
    // 关闭对话框
    editDialogClose () {
      this.$refs.editFormRef.resetFields()
      this.editForm = {
        id: null,
        fullName: '',
        email: '',
        country: '',
        institution: '',
        note: '',
        status: 0
      }
    },
    // 删除
    handleDelete (row) {
      this.$confirm('确认删除该条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.id
        }
        deleteOverseasContactUs(params).then((res) => {
          console.log('deleteOverseasContactUs', res)
          this.$message.success('删除成功')
          this.getDataList()
        }).catch((err) => {
          console.log('删除失败', err)
          this.$message.error('删除失败')
        })
      }).catch(() => {
        // 用户取消删除，不做任何操作
      })
    },
    // 打开修改状态弹窗
    handleUpdateStatus (row) {
      this.statusForm.id = row.id
      this.statusForm.status = row.status
      this.statusDialogVisible = true
    },
    // 提交修改状态
    submitUpdateStatus () {
      this.$refs.statusFormRef.validate(async valid => {
        if (!valid) return

        const params = {
          id: this.statusForm.id,
          status: this.statusForm.status
        }
        updateOverseasContactUsStatus(params).then((res) => {
          console.log('updateOverseasContactUsStatus', res)
          this.$message.success('状态修改成功')
          this.statusDialogVisible = false
          this.getDataList()
        }).catch((err) => {
          console.log('状态修改失败', err)
          this.$message.error('状态修改失败')
        })
      })
    },
    // 关闭修改状态弹窗
    statusDialogClose () {
      this.$refs.statusFormRef.resetFields()
      this.statusForm = {
        id: null,
        status: null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.text-ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}</style>
